/*
 *
 * PublicViewEvent
 *
 */

// window.disableCache = true;

import React, { useEffect, useState } from 'react';
import throttle from 'helpers/throttle';
import isDOM from 'helpers/isDOM';

import handleAnalytics from 'helpers/handleAnalytics';
import injectComponent from 'helpers/injectComponent';
import selectLinkedSection from 'helpers/selectLinkedSection';
import selectVenueById from 'helpers/selectVenueById';
import cacheHandler from 'helpers/cacheHandler';

import {
  selectCurrentPage,
  setSectionsContent,
  fnSetStyling
} from './helpers';

import PublicViewEventWrapperNotFound from './styles/PublicViewEventWrapperNotFound';

import RendererComponent from './RendererComponent';

if (isDOM) {
  window.anonUserIdString;
  window.guessTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  window.isInitial = true;
  window.urlSearchParams = {};
  window.isFrameSpeaker = window.location.search.includes('isFrameSpeaker=true');
  if (window.isFrameSpeaker) {
    const styleElement = document.createElement('style');
    styleElement.appendChild(document.createTextNode(`

        #PublicViewEventWrapper-id, body, html, #app {
          min-height: 100vh !important;
        }
      
        body {
          background: transparent !important;
        }

      `
    ));
    document.head.appendChild(styleElement);
  }

  const urlSearch = new URLSearchParams(window.location.search);

  if (urlSearch) {
    urlSearch.forEach(function (val, key) {
      if (key.includes('utm_')) window.urlSearchParams[key] = val;
    });  
  }
}

function getPageSlug(params, thisEventData) {
  
  if (!thisEventData) return;

  const {
    pageSlug
  } = params;

  const thisPageSlug = pageSlug === 'location' ? '/' : pageSlug ? pageSlug : '/';
  return selectCurrentPage(thisEventData, thisPageSlug);

}

function handleResize() {
  const windowWidthInner = isDOM ? window.innerWidth : 1920;

  let thisSize = '';

  if (windowWidthInner <= 600) {
    thisSize = '37_5';
  } else if (windowWidthInner <= 1228) {
    thisSize = '76_8';
  }

  return thisSize;
}

function getParams(thisPath) {
  if (!thisPath) return {};
  const isLocation = thisPath.includes('/location/');
  const path = isLocation? thisPath.replace('/location/', '/') : thisPath.substring(1);
  const route = isLocation ? ':chapterSlug/:chapterSlug/:pageSlug/:secondSlug' : ':pageSlug/:secondSlug';

  const parts = path.split('/');
  const keys = route.split('/').filter(part => part.charAt(0) === ':').map(part => part.substring(1));
  const names = {};

  keys.forEach((key, index) => {
    if (parts[index]) {
      names[key] = parts[index];
    }
  });

  return names;
}

function returnNotFound() {
  return <PublicViewEventWrapperNotFound>{window.errorTextVar ? window.errorTextVar : '404 - Nothing here... :('} <br/><br/>Go back to <a href={'https://acara.io/'} rel={'noopener'} >Acara</a></PublicViewEventWrapperNotFound>;
}

const params = getParams(isDOM ? window.location.pathname : '');

function PublicViewEvent(props) {

  const thisEventData = props.eventData ? props.eventData : window.eventData;
  const templateSchema = thisEventData?.template?.templateSchema;
  const organizationData = thisEventData?.template?.organizationData;
 

  const {
    chapterSlug,
    pageSlug,
    secondSlug
  } = params;


  const {
    agenda,
    presentations,
    title,
    dateFrom,
    dateTo,
    dateToWithTime,
    dateFromWithTime,
    defaultVenue,
    venues,
    tickets,
    speakers,
    companies
  } = templateSchema;
  
  const currentPage = getPageSlug(params, thisEventData)?.pageId;

  const sectionsData = setSectionsContent(params, templateSchema, currentPage);
  const [windowWidth, setWindowWidth] = useState(handleResize());
  const [loaded, setHowManyLoaded] = useState(false);
  const [pages, setPages] = useState(() => {
    if (templateSchema?.pages) {
      return templateSchema?.pages.map((thisPage) => {
        return {
          title: thisPage.title,
          slug: thisPage.slug,
          pageId: thisPage.pageId
        }});
    }
    return [];
  });


  const [agendaData, setAgendaData] = useState({
    presentations: presentations,
    agenda: agenda,
  });

  const [defaultValues, setDefaultValues] = useState(() => {

    const thisValue = {
      title: title,
      dateFrom: dateFrom,
      dateTo: dateTo,
      dateToWithTime: dateToWithTime,
      dateFromWithTime: dateFromWithTime,
      timezone: templateSchema.timezone,
      twitterAccount: templateSchema.twitterAccount,
      facebookAccount: templateSchema.facebookAccount,
      linkedinAccount: templateSchema.linkedinAccount,
      instagramAccount: templateSchema.instagramAccount,
      slackAccount: templateSchema.slackAccount,
      city: templateSchema.city,
      isOnline: templateSchema.isOnline,
    };
  
    const selectVenue = defaultVenue ? selectVenueById(venues, defaultVenue) : '';
    if (selectVenue) thisValue.defaultVenueData = selectVenue;



    if (speakers && speakers.length) thisValue.speakerLength = speakers.length;
    if (companies && companies.length) thisValue.companiesLength = companies.length;
    if (agendaData && agendaData.agenda && agendaData.agenda.length) thisValue.daysLength = agendaData.agenda.length;
    thisValue.attendeesLength = speakers && speakers.length ? speakers.length : 0;


    thisValue.attendeesLength = speakers && speakers.length ? speakers.length : 0;

    if (tickets && tickets.length) {
      for (let index = 0; index < tickets.length; index++) {
        const element = tickets[index];
        if (element.numberSold) thisValue.attendeesLength = thisValue.attendeesLength + element.numberSold;
      }
    }


    return thisValue;
  });



  useEffect(() => {
    
    const currentContent = {...props, ...sectionsData, pagePath: window.location.pathname, href: window.location.href};
    if (isInitial && !window.isFrameSpeaker) handleAnalytics(currentContent, isInitial, null, false);

    function resizeEvent() {
      setWindowWidth(handleResize());
      return null;
    }

    window.addEventListener('resize', throttle(resizeEvent, 1));

    return () => window.removeEventListener('resize', throttle(resizeEvent, 1));
  }, []); 

  useEffect(() => {

    const loadStuff = async () => {
      {currentPage && templateSchema ? await Promise.all(sectionsData?.sections?.map( async (section, indexSection) => {
        if (section) {
          const {
            savedSections,
            customStyles
          } = templateSchema
          const thisSectionSelect = selectLinkedSection(savedSections, section.sectionIdLinked ? section.sectionIdLinked : section.sectionId, section);
          const getSectionData = thisSectionSelect.section ? thisSectionSelect.section : thisSectionSelect;
          

          const thisComponent = await injectComponent(getSectionData.type, getSectionData.componentName, 'component');
          if (!cacheHandler('get', 'injectCache', section.sectionIdLinked ? section.sectionIdLinked : section.sectionId)) {
            const setStyling = await fnSetStyling(getSectionData, thisSectionSelect, customStyles);
            if (setStyling) cacheHandler('set', 'injectCache', section.sectionIdLinked ? section.sectionIdLinked : section.sectionId, setStyling);
          }
        }
      })) : ''}

      setHowManyLoaded(true);
    }

    if (sectionsData) loadStuff();
    
  }, []); 
  


  return (    
    <div id={'PublicViewEventWrapper-id'}>
      {
        templateSchema && templateSchema.customStyles && templateSchema.customStyles.defaultFont ? (
          <style>
            {`
              #PublicViewEventWrapper-id {
                font-family:${templateSchema.customStyles.defaultFont};
              }
            `}
          </style>
        ): ''
      }

      {templateSchema && templateSchema.templateId && currentPage ? (
        <>
          {currentPage && loaded ? sectionsData?.sections?.map((section, indexSection) => {
            if (section) {
              // return <div key={`PublicViewEvent-RendererComponent-`+section.sectionId}>dsad</div>
              return (
                <RendererComponent
                  section={section}
                  templateSchema={templateSchema}
                  pageSlug={pageSlug}
                  secondSlug={secondSlug}
                  chapterSlug={chapterSlug}
                  params={params}
                  windowWidth={windowWidth}
                  currentPage={currentPage}
                  key={`PublicViewEvent-RendererComponent-`+section.sectionId}
                  thisSectionData={section}
                  indexSection={indexSection}
                  pages={pages}
                  defaultValues={defaultValues}
                  agendaData={agendaData}
                  organization={organizationData}
                />
              );
            }
          }) : ''}
        </>
      ) : returnNotFound()}
    </div>
  );
}

export default PublicViewEvent;


